const GROUP_SEPARATOR = " ";

export function cleanIntegerInput(value: string): string {
  return value.replace(/\D/g, "");
}

export function formatIntegerInput(value: string): string {
  const digits = cleanIntegerInput(value);
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, GROUP_SEPARATOR);
}

/** Convert backend Numeric money (for example "436800.00") to input digits. */
export function serverMoneyInputValue(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return "";
  const amount = Number(String(value).replace(/\s/g, ""));
  return Number.isFinite(amount) ? String(Math.trunc(amount)) : "";
}

export function formatQuantity(value: string | number): string {
  const source = String(value);
  if (!source.includes(".")) return source;
  const trimmed = source.replace(/(\.\d*?[1-9])0+$|\.0+$/, "$1");
  return trimmed === "-0" ? "0" : trimmed;
}
